export default __webpack_public_path__ + "media/images/tenant/chooseTabas/reason_1-e581c594bb02919ef4fce257b1960632.jpg";